import React, { useState } from "react";
import "../style/FAQs.css";
import LeaveMessage from "./LeaveMessage";

const FaqPage = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
    <div id="searchResults"></div>
    <LeaveMessage />

      {/* ===== Heading ===== */}
      <section>
        <div className="heading-section">
          <h2>FAQs</h2>
        </div>
      </section>

      {/* ===== FAQ Content ===== */}
      <section>
        <div className="faq-question">
          {/* question 1 */}
          <div>
            <h6>
              <strong>
                <span className="q">Q:</span> How to choose the tubular motor suitable for you?
              </strong>
            </h6>
            <p>
              <strong>
                <span className="a">A:</span>
              </strong>{" "}
              You first need to determine how much torque you need for the tubular motor? The calculation formula for torque is: torque (Nm) ﹦ coil radius (mm) x load (kg) ÷ 100, for example: to extract 50kg load, how much in theory The torque of the motor? (The radius of the coil is 30mm), the torque algorithm is: torque (Nm) ﹦ 30mmx50kg ÷ 100 = 15N.m. 2. How many kilograms can your motor carry? Weight (kg) = torque (N.m) x 100 ÷ radius of coiled tube (mm). For example: the torque of your motor is 15N.m, how many kilograms can the theoretical load be? (The radius of the coil is 30mm), the weight (kg) = 15N.mx100 ÷ 30 (mm) = 50kg.
            </p>
          </div> <br /><br />

          {/* question 2 */}
          <div>
            <h6>
              <strong>
                <span className="q">Q:</span> What are the advantages of constant speed motors?
              </strong>
            </h6>
            <p>
              <strong>
                <span className="a">A:</span>
              </strong>{" "}
               The working principle of a constant speed motor is to change the average ratio of the armature voltage and change the average value of the armature voltage to control the constant speed of the motor by changing the width of the on pulse and changing the duty cycle of the voltage on the armature of the DC motor, that is, the time ratio of the high and low level of the square wave Run. Its advantage is: after the motor is powered on, press the transmitter, each motor runs at the same speed, keeps the same horizontal line, neat and beautiful.
            </p>
          </div> <br /><br />

          {/* question 3 */}
          <div>
            <h6>
              <strong>
                <span className="q">Q:</span> What are the advantages of helical gear transmission?
              </strong>
            </h6>
            <p>
              <strong>
                <span className="a">A:</span>
              </strong>{" "}
               1. Good meshing performance. The contact line of the helical gear teeth is a straight line inclined to the gear axis. The gear teeth begin to mesh and disengage gradually, so the transmission is smooth and the noise is low. At the same time, this meshing method also reduces the impact of manufacturing errors on the transmission. The ordinary spur gears are simultaneously engaged along the width of the teeth, resulting in shock vibration noise and unstable transmission. 2. The degree of coincidence is large. The load of each pair of gear teeth can be reduced, thereby relatively improving the load-bearing capacity of the gear, extending the service life of the gear, and making the transmission more stable.

            </p>
          </div> <br /><br />

          {/* question 4 */}
          <div>
            <h6>
              <strong>
                <span className="q">Q:</span> What are the advantages of multi-point electronic limit?
              </strong>
            </h6>
            <p>
              <strong>
                <span className="a">A:</span>
              </strong>{" "}
              The 4 middle limit points more than ordinary motors allow you to choose the limit points according to the different light angles during the use of curtains, and control the shading effect is flexible and convenient. 2. Multiple curtains can be easily stopped on the same horizontal line at the same time, making your living environment comfortable and beautiful. 3. Can be applied to more different types of curtains, use more humane.
            </p>
          </div><br /><br />

          {/* question 5 */}
          <div>
            <h6>
              <strong>
                <span className="q">Q:</span> What are the advantages of zero clearance?
              </strong>
            </h6>
            <p>
              <strong>
                <span className="a">A:</span>
              </strong>{" "}
              Zero-gap ultra-quiet electronic limit tubular motor The zero-gap refers to the zero gap between the bracket and the finished coiled tube, which is mainly achieved by completely hiding the motor limit head into the finished coiled tube. Its advantage is to effectively solve the problem that the gap between the two sides of the traditional roller blind is too exposed, the comfort is poor, and it is not conducive to protecting user privacy.
            </p>
          </div> <br /><br />

          {/* question 6 */}
          <div>
            <h6>
              <strong>
                <span className="q">Q:</span> What are herringbone teeth?
              </strong>
            </h6>
            <p>
              <strong>
                <span className="a">A:</span>
              </strong>{" "}
              Remember Citroen's car logo, it's that shape! The herringbone gear runs smoothly, with low noise and no axial force! The helical gear has a transverse force to the axial direction. To eliminate this force, a gear is made into a symmetrical helical gear with opposite directions. It looks like a personal character, referred to as a herringbone tooth! Andre Citroen is the inventor of the herringbone gear!
            </p>
          </div>
        </div>
      </section>

     
    </>
  );
};

export default FaqPage;
